/**
 * @param {() => void} callback
 */
export function viewTransition(callback) {
    if (!document.startViewTransition) {
        callback();
        return;
    }

    document.startViewTransition(callback);
}